import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TaxState } from '../reducers';

export const selectTaxState = createFeatureSelector<TaxState>('tax');

export const selectTaxLoading = createSelector(selectTaxState,(state: TaxState) => state.loading);

export const selectTaxId = createSelector(selectTaxState,(state: TaxState) => state.taxId);

export const selectTax = createSelector(selectTaxState,(state: TaxState) => state.taxList);

export const selectTaxError = createSelector(selectTaxState,(state: TaxState) => state.error);
